import GlobalStyles from '@mui/joy/GlobalStyles';
import Box from '@mui/joy/Box';
import Link from '@mui/joy/Link';
import { Badge, ListItemDecorator, useColorScheme } from "@mui/joy";
import IconButton from '@mui/joy/IconButton';
import Input from '@mui/joy/Input';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemButton, { listItemButtonClasses } from '@mui/joy/ListItemButton';
import ListItemContent from '@mui/joy/ListItemContent';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';

import FiberNewRoundedIcon from '@mui/icons-material/FiberNewRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { PeopleRounded } from '@mui/icons-material';
import LaunchIcon from '@mui/icons-material/Launch';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import BrightnessAutoRoundedIcon from '@mui/icons-material/BrightnessAutoRounded';
import AccessibilityNewRoundedIcon from '@mui/icons-material/AccessibilityNewRounded';
import MessageRoundedIcon from '@mui/icons-material/MessageRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import QuizRoundedIcon from '@mui/icons-material/QuizRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';

import { closeSidebar } from '../../utils';
import { useLocation, useNavigate } from 'react-router';
import { Divider, Stack } from '@mui/joy';
import { useContext, useState } from 'react';
import { LayoutContext } from '../../context';




export default function Sidebar() {
  const { mode, setMode } = useColorScheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { currentDoctor, newRequestsCount, overdueAppointmentsCount, logout } = useContext(LayoutContext);
  
  // Состояние для раскрытия подменю тестирования
  const [ testsExpanded, setTestsExpanded ] = useState(false);

  // Функция для переключения темы
  const toggleTheme = () => {
    if (mode === 'light') {
      setMode('dark');
    } else {
      setMode('light');
    }
  };

  const handleLogout = () => {
    logout();
    closeSidebar();
    navigate('/login/doctor', { replace: true });
  };

  return (
    <Sheet
      className="Sidebar"
      sx={{
        position: { xs: 'fixed', md: 'sticky' },
        transform: {
          xs: 'translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))',
          md: 'none',
        },
        transition: 'transform 0.4s, width 0.4s',
        zIndex: 10020,
        height: { xs: '100dvh', sm: "-webkit-fill-available" },
        width: 'var(--Sidebar-width)',
        top: 0,
        p: 2,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        borderRight: '1px solid',
        borderColor: 'divider',
      }}
    >
      <GlobalStyles
        styles={(theme) => ({
          ':root': {
            '--Sidebar-width': '220px',
            [theme.breakpoints.up('lg')]: {
              '--Sidebar-width': '240px',
            },
          },
        })}
      />
      <Box
        className="Sidebar-overlay"
        sx={{
          display: { xs: 'block', md: 'none' },
          position: 'fixed',
          zIndex: 9998,
          top: 0,
          left: "0px",
          width: '100vw',
          height: '100vh',
          opacity: 'var(--SideNavigation-slideIn)',
          backgroundColor: 'var(--joy-palette-background-backdrop)',
          transition: 'opacity 0.4s',
          transform: {
            xs: 'translateX(calc(120% * (var(--SideNavigation-slideIn, 0) - 1) + var(--SideNavigation-slideIn, 0) * var(--Sidebar-width, 0px)))',
            lg: 'translateX(-120%)',
          },
        }}
        onClick={() => closeSidebar()}
      />
      <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
        {/* <IconButton variant="soft" color="primary" size="sm">
          <BrightnessAutoRoundedIcon />
        </IconButton> */}
        <Typography level="title-lg" sx={{ lineHeight: 1.1 }}>Здоровье</Typography>
        
        {/* Кнопка переключения темы */}
        <IconButton
          variant="outlined"
          color="neutral"
          size="sm"
          onClick={toggleTheme}
          sx={{ mr: 1 }}
        >
          {mode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
        </IconButton>

      </Stack>
      <Divider/>
      {/* <Input size="sm" startDecorator={<SearchRoundedIcon />} placeholder="Поиск..." /> */}
      <Stack
        sx={{
          minHeight: 0,
          overflow: 'hidden auto',
          flexGrow: 1,
          height: "-webkit-fill-available",
          display: 'flex',
          flexDirection: 'column',
          [`& .${listItemButtonClasses.root}`]: {
            gap: 1.5,
          },
        }}
      >
        <List
          size="sm"
          sx={{
            gap: 0.5,
            '--List-nestedInsetStart': '30px',
            '--ListItem-radius': (theme) => theme.vars.radius.sm,
          }}
        >
          {/* <ListItem>
            <ListItemButton onClick={() => {
                navigate('/', { replace: true });
                closeSidebar();
              }} 
              variant={location.pathname == '/' ? 'soft' : 'plain'} color={location.pathname == '/' ? 'primary' : 'neutral'}
            >
              <HomeRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Главная</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem> */}
          
          <ListItem>
            <ListItemButton onClick={() => {
                navigate('/', { replace: true });
                closeSidebar();
              }}
              variant={location.pathname == '/' ? 'soft' : 'plain'} color={location.pathname == '/' ? 'primary' : 'neutral'}
            >
              <AccessibilityNewRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Главная</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>
          
          <ListItem>
            <ListItemButton onClick={() => {
                navigate('/chats', { replace: true });
                closeSidebar();
              }}
              variant={location.pathname == '/chats' ? 'soft' : 'plain'} color={location.pathname == '/chats' ? 'primary' : 'neutral'}
            >
              <MessageRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Чаты</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>

          {/* Статистика чатов — врач/админ/модератор/супервизор */}
          { (currentDoctor?.type_profile?.includes('admin') || currentDoctor?.type_profile?.includes('doctor') || currentDoctor?.type_profile?.includes('moderator') || currentDoctor?.type_profile?.includes('supervisor')) && (
            <ListItem>
              <ListItemButton onClick={() => {
                  navigate('/chat-stats', { replace: true });
                  closeSidebar();
                }}
                variant={location.pathname == '/chat-stats' ? 'soft' : 'plain'} color={location.pathname == '/chat-stats' ? 'primary' : 'neutral'}
              >
                <BarChartRoundedIcon />
                <ListItemContent>
                  <Typography level="title-sm">Статистика чатов</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
          )}

          {/* Приёмы пациентов — врач/админ/супервизор/модератор */}
          {(currentDoctor?.type_profile?.includes('admin') || currentDoctor?.type_profile?.includes('doctor') || currentDoctor?.type_profile?.includes('moderator') || currentDoctor?.type_profile?.includes('supervisor')) && (
            <ListItem>
              <Badge
                badgeContent={overdueAppointmentsCount}
                color="danger"
                size="sm"
                invisible={!overdueAppointmentsCount}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                sx={{
                  '& .MuiBadge-badge': {
                    fontSize: '0.6rem',
                    height: '16px',
                    minWidth: '16px',
                  },
                  width: '100%'
                }}
              >
                <ListItemButton onClick={() => {
                    navigate('/appointments', { replace: true });
                    closeSidebar();
                  }}
                  variant={location.pathname == '/appointments' ? 'soft' : 'plain'}
                  color={location.pathname == '/appointments' ? 'primary' : 'neutral'}
                  sx={{ width: '-webkit-fill-available' }}
                >
                  <CalendarMonthRoundedIcon />
                  <ListItemContent>
                    <Typography level="title-sm">Приёмы</Typography>
                  </ListItemContent>
                </ListItemButton>
              </Badge>
            </ListItem>
          )}

          {/* Заблокированные — только админ/модератор/супервизор */}
          { (currentDoctor?.type_profile?.includes('admin') || currentDoctor?.type_profile?.includes('moderator') || currentDoctor?.type_profile?.includes('supervisor')) && (
            <ListItem>
              <ListItemButton onClick={() => {
                  navigate('/blocked-profiles', { replace: true });
                  closeSidebar();
                }}
                variant={location.pathname == '/blocked-profiles' ? 'soft' : 'plain'} color={location.pathname == '/blocked-profiles' ? 'primary' : 'neutral'}
              >
                <BlockRoundedIcon />
                <ListItemContent>
                  <Typography level="title-sm">Заблокированные</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
          )}

          <ListItem>
            <Badge 
              badgeContent={newRequestsCount} 
              color="danger" 
              size="sm"
              invisible={newRequestsCount === 0}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              sx={{ 
                '& .MuiBadge-badge': {
                  fontSize: '0.6rem',
                  height: '16px',
                  minWidth: '16px',
                },
                width: '100%'
              }}
            >
              <ListItemButton onClick={() => {
                  navigate('/client-requests', { replace: true });
                  closeSidebar();
                }}
                variant={location.pathname == '/client-requests' ? 'soft' : 'plain'} color={location.pathname == '/client-requests' ? 'primary' : 'neutral'}
                sx={{ width: '-webkit-fill-available' }}
              >
                <FiberNewRoundedIcon />
                <ListItemContent>
                  <Typography level="title-sm">Заявки</Typography>
                </ListItemContent>
              </ListItemButton>
            </Badge>
          </ListItem>
            
          { (currentDoctor?.type_profile.includes('admin') || currentDoctor?.type_profile?.includes('admin') || currentDoctor?.type_profile.includes('doctor') || currentDoctor?.type_profile?.includes('doctor') || currentDoctor?.type_profile.includes('supervisor') || currentDoctor?.type_profile?.includes('supervisor')) && (
            <ListItem>
              <ListItemButton onClick={() => {
                  navigate('/users', { replace: true });
                  closeSidebar();
                }}
                variant={location.pathname == '/users' ? 'soft' : 'plain'} color={location.pathname == '/users' ? 'primary' : 'neutral'}
              >
                <PeopleRounded />
                <ListItemContent>
                  <Typography level="title-sm">Пользователи</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
          )}
          
          { (currentDoctor?.type_profile.includes('admin') || currentDoctor?.type_profile?.includes('admin') || currentDoctor?.type_profile.includes('supervisor') || currentDoctor?.type_profile?.includes('supervisor')) && (
            <ListItem>
              <ListItemButton 
                onClick={() => {
                  navigate('/settings', { replace: true });
                  closeSidebar();
                }}
                variant={location.pathname == '/settings' ? 'soft' : 'plain'} 
                color={location.pathname == '/settings' ? 'primary' : 'neutral'}
              >
                <SettingsRoundedIcon />
                <ListItemContent>
                  <Typography level="title-sm">Настройки</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
          )}

          {/* Пункт меню Тестирование с подменю */}
          { (currentDoctor?.type_profile.includes('admin') || currentDoctor?.type_profile?.includes('admin') || currentDoctor?.type_profile.includes('doctor') || currentDoctor?.type_profile?.includes('doctor') || currentDoctor?.type_profile.includes('supervisor') || currentDoctor?.type_profile?.includes('supervisor')) && (
            <ListItem nested>
              <ListItemButton
                onClick={() => setTestsExpanded(!testsExpanded)}
                variant={location.pathname.startsWith('/tests') ? 'soft' : 'plain'}
                color={location.pathname.startsWith('/tests') ? 'primary' : 'neutral'}
              >
                <QuizRoundedIcon />
                <ListItemContent>
                  <Typography level="title-sm">Тестирование</Typography>
                </ListItemContent>
                {testsExpanded ? <KeyboardArrowUpRoundedIcon /> : <KeyboardArrowDownRoundedIcon />}
              </ListItemButton>
              
              {testsExpanded && (
                <List sx={{ gap: 0.5 }}>
                  <ListItem sx={{ pl: 4 }}>
                    <ListItemButton
                      onClick={() => {
                        navigate('/tests/results', { replace: true });
                        closeSidebar();
                      }}
                      variant={location.pathname === '/tests/results' ? 'soft' : 'plain'}
                      color={location.pathname === '/tests/results' ? 'primary' : 'neutral'}
                      sx={{ pl: 3, mt: 0.5 }}
                    >
                      <ListItemDecorator>📊</ListItemDecorator>
                      <ListItemContent>
                        <Typography level="body-sm" sx={{ lineHeight: 1.2 }}>Результаты тестирования</Typography>
                      </ListItemContent>
                    </ListItemButton>
                  </ListItem>
                  
                  <ListItem sx={{ pl: 4 }}>
                    <ListItemButton
                      onClick={() => {
                        navigate('/tests/test-assignments', { replace: true });
                        closeSidebar();
                      }}
                      variant={location.pathname === '/tests/test-assignments' ? 'soft' : 'plain'}
                      color={location.pathname === '/tests/test-assignments' ? 'primary' : 'neutral'}
                      sx={{ pl: 3 }}
                    >
                      <ListItemDecorator>▶️</ListItemDecorator>
                      <ListItemContent>
                        <Typography level="body-sm" sx={{ lineHeight: 1.2 }}>Назначения тестов</Typography>
                      </ListItemContent>
                    </ListItemButton>
                  </ListItem>

                  <ListItem sx={{ pl: 4 }}>
                    <ListItemButton
                      onClick={() => {
                        navigate('/tests/list', { replace: true });
                        closeSidebar();
                      }}
                      variant={location.pathname === '/tests/list' ? 'soft' : 'plain'}
                      color={location.pathname === '/tests/list' ? 'primary' : 'neutral'}
                      sx={{ pl: 3 }}
                    >
                      <ListItemDecorator>📝</ListItemDecorator>
                      <ListItemContent>
                        <Typography level="body-sm">Тесты</Typography>
                      </ListItemContent>
                    </ListItemButton>
                  </ListItem>
                </List>
              )}
            </ListItem>
          )}
        </List>
      </Stack>

      <Divider />
      <List size="sm" sx={{ gap: 0.5, '--ListItem-radius': (theme) => theme.vars.radius.sm }}>
        <ListItem>
          <ListItemButton
            onClick={() => { navigate('/sessions'); closeSidebar(); }}
            variant={location.pathname === '/sessions' ? 'soft' : 'plain'}
            color={location.pathname === '/sessions' ? 'primary' : 'neutral'}
          >
            <DevicesRoundedIcon />
            <ListItemContent>
              <Typography level="title-sm">Устройства и сеансы</Typography>
            </ListItemContent>
          </ListItemButton>
        </ListItem>
        <ListItem>
          <ListItemButton color="danger" variant="plain" onClick={handleLogout}>
            <LogoutRoundedIcon />
            <ListItemContent>
              <Typography level="title-sm">Выйти</Typography>
            </ListItemContent>
          </ListItemButton>
        </ListItem>
      </List>
    </Sheet>
  );
}
